import React from 'react';
import { STRIPE_PAYMENT_LINK } from '../config';
import './Retailers.css';

function Retailers() {
  return (
    <section className="retailers-section" id="retailers">
      <div className="retailers-inner reveal">
        <h2>GET YOUR COPY</h2>
        <div className="red-rule"></div>
        <div className="retailers-ctas">
          <a
            href="https://www.amazon.com/Saving-Grace-Atiba-Madyun/dp/B085RNP7DG"
            className="retailer-btn retailer-btn-outline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Buy on Amazon
          </a>
          <a
            href={STRIPE_PAYMENT_LINK}
            className="retailer-btn retailer-btn-red"
            target="_blank"
            rel="noopener noreferrer"
          >
            Buy Autographed Copy
          </a>
        </div>
      </div>
    </section>
  );
}

export default Retailers;
